/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IMaleOrFemaleOrNonBinary {
  Male = 'male',
  Female = 'female',
  NonBinary = 'non-binary',
}
